import React from "react";
import { Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import constant from "lib/constant/constant";
import config from "configuration";
import PrivateContainer from "./privateContainer";

// import helpers
import { storageHelper, baseHelper } from "../../lib/helpers";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const url = baseHelper.parseUrl(config.rootURL);
  const isCustomDomain = window.location.hostname !== url.hostname;

  const reloadApp = () => {
    const shop = storageHelper.get("shop");
    if (shop) {
      const shopifyURL = baseHelper.getShopifyURL(shop);
      if (shopifyURL) {
        window.top.location.href = shopifyURL;
      }
    }
  };

  const isIframe = baseHelper.isIframe();
  const token = storageHelper.get("token");

  if (isIframe && !token) {
    reloadApp();
    return null;
  }

  if (!token) {
    return (
      <Navigate
        to={
          isCustomDomain && ["uat-qa-1.marketcube.io", "innoterra.marketcube.io"].includes(window.location.hostname)
            ? "/prelogin"
            : "/login"
        }
        state={{ from: location }}
        replace
      />
    );
  }

  return <PrivateContainer navigate={navigate}>{children}</PrivateContainer>;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
